import HideHeaderButtons from 'src/javascripts/components/tables/checkboxes/HideHeaderButtons';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';

// Bulk update using selected record IDs from a table
export default function(tableId) {

  // Update bulk
  $('.update-bulk').off().on('click', function() {
    let url = $(this).data('url');
    let params = {};
    let updateColumn = $(this).data('column');
    let updateVal = $(this).data('value');
    $(this).closest('.BulkActionDropdown').removeClass('show');
    params[updateColumn] = updateVal;
    params['record_ids'] = $('#' + tableId).data('record-ids');
    $.ajax({
      type: 'PATCH',
      dataType: 'script',
      url: url + '?' + $.param(params),
      complete(result) { 
        $('#' + tableId).DataTable().ajax.reload();
        ToastCustom({title: 'Success', message: 'Successfully updated selected records', delay: 8000, autohide: true, type: 'success'});
        HideHeaderButtons(tableId);
      }
    });
  })


}
